<script lang="ts">
import { defineComponent } from '@mimir/web/compat/vueCompat';
import { VSwitch } from 'vuetify/lib';

export default defineComponent({
  name: 'MSwitch',
  components: {
    VSwitch,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
    },
  },
  computed: {
    proxy: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean) {
        this.$emit('input', val);
      },
    },
  },
});
</script>

<template>
  <VSwitch
    v-bind="$attrs"
    v-model="proxy"
    class="m-switch mt-1"
    :ripple="false"
    hide-details="auto"
    v-on="$listeners"
  >
    <template
      v-for="(_, name) in $slots"
      #[name]
    >
      <slot :name="name" />
    </template>
    <template
      v-for="(_, name) in $scopedSlots"
      #[name]="data"
    >
      <slot
        :name="name"
        v-bind="data"
      />
    </template>
  </VSwitch>
</template>

<style lang="stylus" scoped>
  .m-switch
    &:hover :deep(.v-label)
      color: var(--v-strong-base)
    &.v-input--is-focused :deep(.v-input--switch__track)
      border-color: var(--v-strong-base)
    :deep(.v-input--switch__track)
      height: 20px
      border-radius: 10px
      border: 1px solid transparent
      top: calc(50% - 10px);
      &.primary--text
        color: var(--v-primary-base) !important
    :deep(.v-input--switch__thumb)
      margin-left: 4px
      top: calc(50% - 8px)
      height: 16px
      width: 16px
      &.primary--text
        width: 8px
        border-radius: 6px
        color: var(--v-default-base) !important
    :deep(label)
      font-size: 12px
    &.theme--light :deep(.v-input--switch__thumb.primary--text)
      color: white !important
</style>
